<template>
  <Breadcrumbs
      title="Distributor Staff"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Staff', path: '/distributor-staff' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <distributorStaff/>
    </div>
  </div>
</template>

<script>
import distributorStaff from './distributor_staff_form.vue'
export default {
  name: 'indexList',
  components: {
    distributorStaff,
  },
}
</script>